<script>
    export let href = '#';
    export let title = '';
</script>

<a
    href="{href}"
    title="{title}"
    class="hover:text-sky-700 h-6 w-6 text-stone-800"
>
    <slot />
</a>
